<template>
  <div class="sel-role-wrapper">
    <!--    <vue-qr v-show="erCode" backgroundColor="#fff" class="er-code" :logoSrc="logo" :text="erCode" :size="180"></vue-qr>-->
    <role-select v-if="this.$store.state.user.userInfo.roleType == 0" >
      <!-- 选择角色 -->
      
    </role-select>
     <parent-list v-if="this.$store.state.user.userInfo.roleType == 2" >
      <!-- 家长的孩子列表 -->
    </parent-list>
    <child-list v-if="this.$store.state.user.userInfo.roleType == 1">
      <!-- 孩子的家长列表 -->
      
    </child-list>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import {  getRecognize } from "@/api/family";
import { wxConfigWXApi } from "@/lib/wxShare";
import * as ActionTypes from "@/store/action-types"
import RoleSelect from "./RoleSelect"
import ParentList from "./ParentList"
import ChildList from "./ChildList"

export default {
  name: "BindParent",
  data() {
    return {
      // logo: this.$store.state.user.userInfo.headImageUrl,
      code: ''
    };
  },

  components: {
      RoleSelect,
      ParentList,
      ChildList
  },

  activated() {
    //每次进入刷新个人信息
    // this.lookUserInfo();
    this.$store.dispatch(ActionTypes.GET_USER_INFO)
    // this.request_getQrcode();

    //每次进入页面去调用微信鉴权,等待鉴权完成才能访问相机扫码功能
    if (navigator.userAgent.indexOf("iPhone") != -1) {
      //ios
      // wxConfigWXApi(window.location.origin + '/home', () => {
      //   this.$loading.hide()
      // });
    } else {
      this.$loading.show();
      wxConfigWXApi(location.origin + this.$route.fullPath, () => {
        this.$loading.hide();
      });
    }
  },

  mounted() {},

  methods: {
    //循环查询用户状态
    lookUserInfo() {
      this.$store.dispatch(ActionTypes.GET_USER_INFO).then((res) => {
        if (res.roleType == 1) {
          //当前用户是家长
          // this.$router.push({
          //   path: '/familyParent'
          // })
          this.$router.replace({
            path: "/familyParent",
          });
        } else if (res.roleType == 2) {
          //当前用户是孩子
          // this.$router.push({
          //   path: '/familyChild'
          // })
          this.$router.replace({
            path: "/familyChild",
          });
        } else {
          setTimeout(() => {
            this.lookUserInfo();
          }, 1000);
        }
      });
    },

    //===============action==================
    //添加孩子
    onButtonClick() {
      // this.request_getRecognize(0, this.code);
      let code = document.getElementById("bind-code-input").value
      // console.log('====>',this.$store.state.user.userInfo)
      this.request_getRecognize(code)
     
    },


    //识别用户二维码 
    request_getRecognize(code) {
      this.$loading.show();
      let params = {
        code: code,
      };
      getRecognize(params).then((res) => {
        this.$loading.hide();
          const result = JSON.stringify(res.data);
        //   this.$router.replace({
        //   path: "/scanAddParent",
        //   query: {
        //     qrcodeResult: result,
        //     callback: () => {
        //       // window.location.replace('/familyChild')
        //     },
        //   },
        // });
          // this.hanleScanResult(tag, result);
     
      }).catch(()=>{
        this.$loading.hide();

      })
    },

    //处理扫描结果
    hanleScanResult(tag, result) {
      //tag: 0 添加孩子  1 添加学生
      // console.log(result)
      if (tag == 0) {
        this.$router.replace({
          path: "/scanAddChild",
          query: {
            qrcodeResult: result,
            callback: () => {
              // window.location.replace('/familyParent')
            },
          },
        });
        // this.$router.push({
        //   path: '/scanAddChild', query: {
        //     qrcodeResult: result, callback: () => {
        //       // window.location.replace('/familyParent')
        //     }
        //   }
        // })
      } else {
        

        // this.$router.push({
        //   path: '/scanAddParent', query: {
        //     qrcodeResult: result, callback: () => {
        //       // window.location.replace('/familyChild')
        //     }
        //   }
        // })
      }
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '../stylesheet/common.styl';

.sel-role-wrapper {
  text-align: center;
}

.center-bg-wrapper {
  margin-top: 50px;
}

.center-bg-img {
  width: 60%;
}

.my-code-text {
  margin-top: 30px;
  font-size: 18px;
  font-weight: bold;
  color: #333333;
}

.code-input-wrapper {
  border: 1px solid #3994E7;
  margin: auto 28px;
  margin-top: 30px;
  line-height: 44px;
  border-radius: 22px;
}

.code-input {
  margin-left: 20px;
  line-height: 44px;
  width: 100%;
  background-color: #00000000;
}

.title {
  font-size: 17px;
  margin-top: 30px;
}

.er-code {
  margin-top: 10px;
  padding: 2px;
  width: 200px !important;
  height: 200px !important;
}

.learn-flow-btn {
  display: block;
  margin: 20px auto;
  font-size: 16px;
}

.home-button {
  height: 44px;
  line-height: 44px;
  font-size: 14px;
  text-align: center;
  color: #ffffff;
  margin: 0 28px;
  margin-top: 30px;
  // width: 100%;
  border-radius: 22px;
  background: linear-gradient(right, #98CEFF, #3994E7);
}
</style>



// WEBPACK FOOTER //
// app/pages/family/RelationShip.vue